'use strict';

var CommentsDirective = function CommentsDirective() {
  return {
    restrict: 'E',
    controller: 'CommentsController',
    scope: {
      entityKey: '=',
      entityData: '=',
      level: '=',
      listOnly: '=',
      fieldListOnly: '=',
      onCommentsUpdated: '&',
      onCommentsClose: '&',
      headerFormat: '@?'
    },
    template: require('../templates/comments.html'),
    link: function link($scope, element) {
      var collapsibleElement = element.find('.form-collapsible');
      var form = element.find('form');
      $scope.hideForm = function () {
        form[0].reset();
        collapsibleElement.collapse('hide');
      };
      $scope.$watch('entityData', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          $scope.updateComments();
        }
      });
    }
  };
};
CommentsDirective.$inject = [];
module.exports = CommentsDirective;